import React from "react";
import Card from "components/card";
import DoughnutChart from "components/charts/DoughnutChart";

const EstimatedHours = ({ chartData }) => {
    const series = Array.isArray(chartData?.series) && chartData.series.length ? chartData.series : [550, 380];
    const labels = Array.isArray(chartData?.labels) && chartData.labels.length ? chartData.labels : ["Clients", "Leads"];
    const total = typeof chartData?.totalEstimatedHours === "number" ? chartData.totalEstimatedHours : series.reduce((a, b) => a + b, 0);
    const chartLabels = [labels[0] ?? "Clients", labels[1] ?? "Leads"];

    const options = {
        labels: chartLabels,
        colors: ["#82E5D1", "#8585EF"],
        tooltip: {
            enabled: true,
        },
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val.toFixed(1) + "%";
            },
        },
        plotOptions: {
            donut: {
                size: "65%",
                dataLabels: {
                    offset: -5,
                },
            },
        },
    };

    return (
        <Card extra="rounded-[20px] p-4">
            <div className="mb-auto flex items-center justify-between px-3 pt-2">
                <div>
                    <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                        Estimated Hours
                    </h2>
                    <p className="text-sm text-gray-600 dark:text-gray-300">
                        Total estimated: {total}h
                    </p>
                </div>
            </div>

            <div className="flex flex-col items-center justify-center pt-4">
                {/* Center: Chart */}
                <div className="flex items-center justify-center mb-6">
                    <div className="h-[280px] w-[280px]">
                        <DoughnutChart series={series} options={options} />
                    </div>
                </div>

                {/* Bottom Badges */}
                <div className="flex flex-row w-full items-end justify-between">
                    {/* Left Badge */}
                    <div className="flex flex-col items-center justify-center">
                        <div className="flex items-center justify-center gap-2 mb-2">
                            <div
                                className="h-3 w-3 rounded-full"
                                style={{ background: options.colors[0] }}
                            />
                            <p className="text-sm font-medium text-gray-600">{chartLabels[0]}</p>
                        </div>
                        <p className="text-lg font-bold text-navy-700 dark:text-white">
                            {series[0]}h
                        </p>
                    </div>

                    {/* Right Badge */}
                    <div className="flex flex-col items-center justify-center">
                        <div className="flex items-center justify-center gap-2 mb-2">
                            <div
                                className="h-3 w-3 rounded-full"
                                style={{ background: options.colors[1] }}
                            />
                            <p className="text-sm font-medium text-gray-600">{chartLabels[1]}</p>
                        </div>
                        <p className="text-lg font-bold text-navy-700 dark:text-white">
                            {series[1]}h
                        </p>
                    </div>
                </div>
            </div>

        </Card>
    );
};

export default EstimatedHours;
